
import '../../frontend-editor-ckeditor-web/__liferay__/exports/ckeditor5$ckeditor5.css.js';
